import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { CookieConsentProvider } from "@/context/CookieConsentContext";
import CookieBanner from "@/components/CookieBanner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordReset";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Support from "@/pages/Support";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

import { Toaster } from "@/components/ui/sonner";

function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FCFCFB]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FCFCFB]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle Emergent Google callback synchronously, before routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/support" element={<Support />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/passwort-vergessen" element={<ForgotPasswordPage />} />
        <Route path="/passwort-neu" element={<ResetPasswordPage />} />
      </Route>
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CookieConsentProvider>
          <AuthProvider>
            <AppRouter />
            <CookieBanner />
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </CookieConsentProvider>
      </BrowserRouter>
    </div>
  );
}
